<template>
  <div class="tendency-circle">
    <i class="fa-solid fa-2x fa-circle-right" :class="getBgColor"></i>
  </div>
</template>

<script>
export default {
  name: 'Tendency',

  props: {
    value: {
      type: Number,
      required: true,
    },
  },

  computed: {
    getBgColor() {
      let color = ''
      if (this.value < -1 ) {
        color = 'text-red-600'
      } else if (this.value === -1 ) {
        color = 'text-orange-500'
      } else if (this.value === 0) {
        color = 'text-yellow-500'
      } else if (this.value === 1 ) {
        color = 'text-success-500'
      } else {
        color = 'text-success-900'
      }

      return color + ' ' + 'tendency--' + this.value
    },
  },
}
</script>

<style scoped>
.tendency--2 {
  transform: rotate(-60deg)
}

.tendency--1 {
  transform: rotate(-30deg)
}

.tendency--0 {

}

.tendency---1 {
  transform: rotate(30deg)
}

.tendency---2 {
  transform: rotate(60deg)
}
</style>